// extracted by mini-css-extract-plugin
export default {"buttonCarousel":"LatestServiceContent_buttonCarousel__UklsO","title":"LatestServiceContent_title__YE8yB"};